var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhilippinesFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55.68 38.88",
    style: {
      enableBackground: "new 0 0 55.68 38.88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0038A8",
    d: "M1.27,37.88l32.2-18.59l20.19,19.08c1.05-0.48,1.79-1.54,1.79-2.76V3.27c0-1.67-1.37-3.03-3.03-3.03H3.27 c-1.67,0-3.03,1.36-3.03,3.03v32.33C0.24,36.51,0.64,37.32,1.27,37.88L1.27,37.88z M51.78,38.64H3.27c-0.66,0-1.27-0.21-1.76-0.57 L51.78,38.64L51.78,38.64z M33.47,19.29L33.47,19.29L1.28,37.88L33.47,19.29L33.47,19.29L33.47,19.29z M33.47,19.29L33.47,19.29 L1.28,37.88L33.47,19.29L33.47,19.29L33.47,19.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CE1126",
    d: "M0.24,19.31h33.2L1.27,37.88c-0.63-0.56-1.03-1.37-1.03-2.28V19.31L0.24,19.31z M55.44,19.31v16.3 c0,1.67-1.37,3.03-3.03,3.03H3.27c-0.77,0-1.47-0.29-2-0.76l32.16-18.57l0,0H55.44L55.44,19.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M33.47,19.29L1.27,37.88c-0.63-0.56-1.03-1.37-1.03-2.28V3.27c0-1,0.49-1.89,1.25-2.45L33.47,19.29 L33.47,19.29L33.47,19.29z M33.47,19.29L33.47,19.29L33.47,19.29L33.47,19.29L33.47,19.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCD116",
    d: "M15.99,19.31c0-2.14-1.74-3.87-3.87-3.87c-2.13,0-3.87,1.74-3.87,3.87c0,2.13,1.74,3.87,3.87,3.87 S15.99,21.44,15.99,19.31L15.99,19.31L15.99,19.31z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FCD116",
    points: "3.93,19.31 4.44,19.82 12.12,19.31 4.44,18.8 3.93,19.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FCD116",
    points: "4.8,20.27 5.2,20.68 12.12,19.31 4.8,20.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FCD116",
    points: "4.8,18.35 5.2,17.94 12.12,19.31 4.8,18.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FCD116",
    points: "6.33,13.52 6.33,14.25 12.12,19.31 7.04,13.52 6.33,13.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FCD116",
    points: "6.26,14.81 6.26,15.39 12.12,19.31 6.26,14.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FCD116",
    points: "7.61,13.45 8.2,13.45 12.12,19.31 7.61,13.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FCD116",
    points: "12.12,11.13 11.61,11.63 12.12,19.31 12.63,11.63 12.12,11.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FCD116",
    points: "11.15,11.99 10.73,12.4 12.12,19.31 11.15,11.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FCD116",
    points: "13.07,11.99 13.49,12.4 12.12,19.31 13.07,11.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FCD116",
    points: "17.9,13.52 17.18,13.52 12.12,19.31 17.9,14.25 17.9,13.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FCD116",
    points: "16.61,13.45 16.02,13.45 12.12,19.31 16.61,13.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FCD116",
    points: "17.97,14.81 17.97,15.39 12.12,19.31 17.97,14.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FCD116",
    points: "20.29,19.31 19.78,18.8 12.12,19.31 19.78,19.82 20.29,19.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FCD116",
    points: "19.44,18.35 19.02,17.94 12.12,19.31 19.44,18.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FCD116",
    points: "19.44,20.27 19.02,20.68 12.12,19.31 19.44,20.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FCD116",
    points: "17.9,25.09 17.9,24.37 12.12,19.31 17.18,25.09 17.9,25.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FCD116",
    points: "17.97,23.8 17.97,23.22 12.12,19.31 17.97,23.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FCD116",
    points: "16.61,25.16 16.02,25.16 12.12,19.31 16.61,25.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FCD116",
    points: "12.12,27.49 12.63,26.98 12.12,19.31 11.61,26.98 12.12,27.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FCD116",
    points: "13.07,26.63 13.49,26.21 12.12,19.31 13.07,26.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FCD116",
    points: "11.15,26.63 10.73,26.21 12.12,19.31 11.15,26.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FCD116",
    points: "6.33,25.09 7.04,25.09 12.12,19.31 6.33,24.37 6.33,25.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FCD116",
    points: "7.61,25.16 8.2,25.16 12.12,19.31 7.61,25.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FCD116",
    points: "6.26,23.8 6.26,23.22 12.12,19.31 6.26,23.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FCD116",
    points: "29.74,19.31 28.28,19.82 28.25,21.35 27.32,20.13 25.84,20.57 26.73,19.31 29.74,19.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FCD116",
    points: "29.74,19.31 28.28,18.8 28.25,17.26 27.32,18.48 25.84,18.05 26.73,19.31 29.74,19.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FCD116",
    points: "2,35.32 2.29,33.82 0.96,33.01 2.5,32.82 2.84,31.33 3.51,32.72 2,35.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FCD116",
    points: "2,35.32 3.16,34.31 4.51,35.06 3.91,33.64 5.04,32.59 3.51,32.72 2,35.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FCD116",
    points: "2,3.3 3.16,4.3 4.51,3.56 3.91,4.97 5.04,6.03 3.51,5.9 2,3.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FCD116",
    points: "2,3.3 2.29,4.81 0.96,5.6 2.5,5.8 2.84,7.3 3.51,5.9 2,3.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#CCCCCC",
    strokeWidth: 0.4799,
    strokeMiterlimit: 22.9256,
    d: "M3.27,0.24h49.13c1.67,0,3.03,1.36,3.03,3.03v32.33c0,1.67-1.37,3.03-3.03,3.03H3.27 c-1.67,0-3.03-1.37-3.03-3.03V3.27C0.24,1.6,1.6,0.24,3.27,0.24L3.27,0.24z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhilippinesFlag);
export default __webpack_public_path__ + "static/media/philippines-flag.6a2449b50e76ebbd5cfeeff5b3305dd5.svg";
export { ForwardRef as ReactComponent };